import { Box, Breadcrumbs, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { ClassNames } from "@emotion/react";
import CustomBreadcrumbStyles from './CustomBreadcrumb.styles';

interface CustomProps {
  breadCrumbList: any;
}

const CustomBreadcrumb = (props: CustomProps) => {
    const classes = CustomBreadcrumbStyles;
  return (
    <Box sx={classes.breadcrumbWrapper}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        {props.breadCrumbList &&
          props.breadCrumbList.map((e: any) => (
            <Typography key={e.name} sx={classes.textStyle}>
              {e.link ? (
                <Link
                  to={{
                    pathname: `${e.link}`,
                    state: e.param,
                  }}
                >
                  {e.name}
                </Link>
              ) : (
                e.name
              )}
            </Typography>
          ))}
      </Breadcrumbs>
    </Box>
  );
};

export default CustomBreadcrumb;
